<template>
  <a-modal
    title="Carry Forward Inventory"
    :visible="visible"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="Carry Forward"
    cancelText="Cancel"
  >
    <div class="mb-4">
      <p class="text-muted">
        Carry forward closing stock from a previous session to a new session as opening stock.
        Only positive stock balances will be transferred. This action will not modify historical data.
      </p>
    </div>

    <a-form :form="form" layout="vertical">
      <a-form-item label="From Session (Old Academic Year)">
        <a-select
          v-decorator="[
            'from_session_id',
            { rules: [{ required: true, message: 'Please select the origin session' }] }
          ]"
          placeholder="Select old session"
          @change="handleFromSessionChange"
        >
          <a-select-option v-for="session in sortedSessions" :key="session.id" :value="session.id">
            {{ session.name }} <small class="text-primary ml-1" v-if="session.is_current">Current</small>
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="To Session (New Academic Year)">
        <a-select
          v-decorator="[
            'to_session_id',
            { rules: [{ required: true, message: 'Please select the destination session' }] }
          ]"
          placeholder="Select new session"
        >
          <a-select-option v-for="session in toSessions" :key="session.id" :value="session.id">
            {{ session.name }} <small class="text-primary ml-1" v-if="session.is_current">Current</small>
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'CarryForwardModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    sessions: {
      type: Array,
      default: () => [],
    },
    currentSession: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      selectedFromSession: null,
    }
  },
  computed: {
    sortedSessions() {
      return [...this.sessions].sort((a, b) => b.id - a.id)
    },
    toSessions() {
      // Filter out the selected from_session_id
      if (!this.selectedFromSession) return this.sortedSessions
      return this.sortedSessions.filter(s => s.id !== this.selectedFromSession)
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.resetFields()
        this.selectedFromSession = null
      }
    },
  },
  methods: {
    handleFromSessionChange(value) {
      this.selectedFromSession = value
      // Reset to_session if it equals from_session
      const currentToSession = this.form.getFieldValue('to_session_id')
      if (currentToSession === value) {
        this.form.setFieldsValue({ to_session_id: undefined })
      }
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$http.post('/api/inventory/product/carry-forward', {
            from_session_id: values.from_session_id,
            to_session_id: values.to_session_id,
          })
            .then(() => {
              this.loading = false
              this.$emit('success')
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        }
      })
    },
    handleCancel() {
      this.form.resetFields()
      this.$emit('close')
    },
  },
}
</script>
